<script>
    export let classe = '';
    export let title;
    export let name; 
    export let type = 'text';
    export let required = '';
    export let rows = 4;
    export let showLabel = true;
    export let defaultValue = '';
    export let selectValues = '';

    switch (name) {
        case 'nome':
            if (defaultValue === '' && window.store.get('field.nome') != null) {
                defaultValue = window.store.get('field.nome');
            }
            break;    
        case 'telefone':
            if (defaultValue === '' && window.store.get('field.telefone') != null) {
                defaultValue = window.store.get('field.telefone');
            }
            break;    
        case 'email':
            if (defaultValue === '' && window.store.get('field.email') != null) {
                defaultValue = window.store.get('field.email');
            }
            break;    
    }
</script>

{#if showLabel == true}
    {#if type === 'select'}
        <div class="form-group">
            <label for="{name}">{title}</label>
            <select class="form-control" id="{name}" name="{name}">
                {#each selectValues as v}
                    <option value="{v.value}">{v.title}</option>
                {/each}
            </select>
        </div>
    {:else if type === 'textarea'}
        <div class="form-group">
            <label for="{name}">{title}</label>
            <textarea {required} class="form-control {classe}" id="{name}" name="{name}" rows={rows}>{defaultValue}</textarea>
        </div>
    {:else}
        <div class="form-group">
            <label for="{name}">{title}</label>
            <input type="{type}" {required} class="form-control {classe}" id="{name}" name="{name}" placeholder="{title}" value="{defaultValue}">
        </div>
    {/if}
{:else}
    {#if type === 'select'}
        <div class="form-group">
            <label style="display: none;" for="{name}">{title}</label>
            <select class="form-control" name="{name}">
                {#each selectValues as v}
                    <option value="{v.value}">{v.title}</option>
                {/each}
            </select>
        </div>
    {:else if type === 'textarea'}
        <div class="form-group">
            <label style="display: none;" for="{name}">{title}</label>
            <textarea {required} class="form-control {classe}" id="{name}" name="{name}" rows={rows}>{defaultValue}</textarea>
        </div>
    {:else}
        <div class="form-group">
            <label style="display: none;" for="{name}">{title}</label>
            <input type="{type}" {required} class="form-control {classe}" id="{name}" name="{name}" placeholder="{title}" value="{defaultValue}">
        </div>
    {/if}
{/if}